import React from 'react';
import { DeleteIcon, EditIcon, EyeIcon } from '../../components/Shared/TableActionIcons';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CustomPagination from '../../components/Shared/CustomPagination';
import { useTranslation } from 'react-i18next';
import { formatTimestamp } from '../../components/Shared/SharedMethods';
import { getVendorList, deleteVendor } from '../../store/slices/PurchaseSlice';
import TableLoading from '../../components/Shared/TableLoading';
import CustomTable from '../../components/Shared/CustomTable';
import ConfirmationModal from '../../components/Shared/ConfirmationModal';
import { FiTrash2 } from 'react-icons/fi';

export default function VendorTable({ data, loading, onPageChange, onRefresh }) {
  const datebody = rowData => {
    return formatTimestamp(rowData.payment_date);
  };

  const { isLoading } = useSelector(state => state.purchase);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [confirmationDialogVisible, setConfirmationDialogVisible] = React.useState(false);
  const [deleteData, setDeleteData] = React.useState(null);

  const handleDeleteVendor = async () => {
    if (deleteData) {
      const response = await dispatch(deleteVendor(deleteData.id)).unwrap();
      if (response) {
        setConfirmationDialogVisible(false);
        setDeleteData(null);
        if (onRefresh) onRefresh();
      }
    }
  };

  const handlePageChange = (newPage, newRowsPerPage) => {
    if (onPageChange) {
      onPageChange(newPage, newRowsPerPage);
    }
  };

  const templateBody = rowData => (
    <div className='flex gap-1'>
      <EyeIcon
        onClick={() => navigate('/manager/vendor/view', { state: { vendor: rowData } })}
        title={t('view')}
      />
      <EditIcon
        onClick={() => navigate('/manager/vendor/create', { state: { vendor: rowData } })}
        title={t('edit')}
      />
      <DeleteIcon
        onClick={() => {
          setDeleteData(rowData);
          setConfirmationDialogVisible(true);
        }}
        title={t('delete')}
      />
    </div>
  );

  const sequenceBodyTemplate = (rowData, options) => {
    return options.rowIndex + 1 + (data?.page - 1) * data?.per_page;
  };

  const columnsData = [
    {
      body: templateBody,
      header: t('actions')
    },
    {
      body: sequenceBodyTemplate,
      header: t('no'),
      style: { width: '3rem' }
    },
    {
      field: 'name',
      header: t('name')
    },
    {
      field: 'vat_no',
      header: t('vatNo')
    },
    {
      field: 'cr_no',
      header: t('crNo')
    },
    {
      field: 'email',
      header: t('email')
    },
    {
      field: 'phone',
      header: t('contact')
    },
    {
      field: 'country',
      header: t('Country')
    },
    {
      field: 'city',
      header: t('city')
    },

  ];

  return (
    <>
      <CustomTable
        data={data?.data}
        isLoading={loading}
        loadingIcon={<TableLoading />}
        columns={columnsData}
        rows={data?.per_page}
      />
      {data?.data?.length > 0 && (
        <CustomPagination
          currentPage={data?.page}
          rowsPerPage={data?.per_page}
          totalRecords={data?.total_pages}
          totalRecord={data?.total_record}
          onPageChange={handlePageChange}
        />
      )}
      <ConfirmationModal
        message={`${t("do_you_really_want_to_delete_this_vendor")} "${deleteData?.name}"?`}
        header={t("delete_confirmation")}
        Icon={FiTrash2}
        isLoading={isLoading}
        visible={confirmationDialogVisible}
        setVisible={setConfirmationDialogVisible}
        onAccept={handleDeleteVendor}
        acceptLabel={t("delete")}
        rejectLabel={t("cancel")}
      />
    </>
  );
}
